import {
  DesignTokenSizeEnum,
  Text,
  TokenTextAppearance,
  TextTag,
} from '@volkswagen-onehub/components-core';
import { useTribalContext } from '@/context/tribal';
import Box from '../Box/Box';
import SocialMediaLinks from '../SocialMediaLinks/SocialMediaLinks';

const FooterSocialMedia = () => {
  const { contentManager } = useTribalContext();

  return (
    <div>
      <Text tag={TextTag.h3} appearance={TokenTextAppearance.bigcopy200} bold>
        {contentManager.get('footer-socialmedia-title')}
      </Text>
      <Box
        as={Text}
        tag="p"
        appearance={TokenTextAppearance.copy200}
        mb={DesignTokenSizeEnum.static250}
      >
        {contentManager.get('footer-socialmedia-description')}
      </Box>
      <Box width="100%">
        <SocialMediaLinks />
      </Box>
    </div>
  );
};

export default FooterSocialMedia;
